module.exports = __webpack_public_path__ + "static/media/claimStats2.b43eabe5.png";